import React, { Fragment } from 'react'

import * as H from 'history'
import { IField, validateFieldsEx } from '../../../../shared/fields'
import { getThisFY } from '../../../../shared/Utility'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import { documentTypeInfo } from '../../documents/DocumentTypeInfo'
import { DocumentSection } from '../../documents/DocumentSection'
import EMDGAccordion from '../../../../shared/EMDGAccordion'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    history: H.History
    preview?: boolean
}

export interface State {
    thisFYStr: string,
}

export default class SupportingDocumention extends React.Component<Props, State> {
  documents: { [code: string]: { [item: string]: DocumentSection } }
  constructor(props: Props) {
    super(props)
    const currDate = new Date()

    this.state = {
      thisFYStr: getThisFY(currDate),
    }
  }

  componentDidUpdate(prevProps: Props) {
  }

  setDocumentRef(code: string, item: string, r: DocumentSection) {
    if (!this.documents) {
      this.documents = {}
    }
    if (!this.documents[code]) {
      this.documents[code] = {}
    }
    this.documents[code][item] = r
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const documentsToValidate: IField[] = []

    for (const t of documentTypeInfo) {
      const items = t.reducer(this.props.model)
      for (const i of items) {
        if (this.documents && this.documents[t.code] && this.documents[t.code][i]) {
          documentsToValidate.push(this.documents[t.code][i])
        }
      }
    }

    validateFieldsEx(
      focus,
      callback,
      ...documentsToValidate,
    )
  }

  render() {
    const {
      model, onChange, history, preview,
    } = this.props

    return (
      <div className="form-item">
        { preview && <h4>Supporting documentation</h4>}
        <EMDGAccordion expanded header="Supporting documentation">
          <div id="supportingDocumentSection">
            You should use a simple naming convention for your supporting documentation, one that identifies what the document relates to.
            <br />
            <br />
            The maximum total number of characters for a file name is 144 characters.
            <br />
            <br />
            The maximum file size is 10MB. Only pdf files are allowed.
            <br />
            <br />
            You must attach the following supporting documentation
            {!preview ? (
              <>
                {documentTypeInfo.map((r) => (
                  <Fragment key={r.code}>
                    {r.reducer(model).map((i) => (
                      <DocumentSection
                        key={i}
                        ref={(_) => this.setDocumentRef(r.code, i, _)}
                        model={model}
                        info={r}
                        item={i}
                        onChange={(applicationDocuments) => onChange({ ...applicationDocuments })}
                        history={history}
                      />
                    ))}
                  </Fragment>
                ))}
              </>
            ) : (
              <table className="table table-sm mt-3">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Attached file</th>
                  </tr>
                </thead>
                <tbody>
                  {documentTypeInfo.map((r) => (
                    <Fragment key={r.code}>
                      {r.reducer(model).map((i) => (
                        <tr key={i}>
                          <td>{r.title(model, i)}</td>
                          <td>
                            {model.applicationDocuments.filter((d) => d.code === r.code).map((f, m, arr) => {
                              const isLastItem = arr.length - 1 === m
                              return (
                                <Fragment key={m}>
                                  {`${f.documentName}${isLastItem ? '' : ',  '}`}
                                </Fragment>
                              )
                            })}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </EMDGAccordion>
      </div>
    )
  }
}
